import { Dispatch, SetStateAction } from "react";

import styled from "styled-components";
import { ChickenNuggets as ChickenNuggestComponent } from "../ChickenNuggets";

type Props = {
  imageUrls: string[];
  index: number;
  setIndex: Dispatch<SetStateAction<number>>;
};

export const ChickenNuggets = ({ imageUrls, index, setIndex }: Props) => {
  return (
    <Container>
      <ChickenNuggestComponent
        index={index}
        nuggets={imageUrls.map((imageUrl, i) => ({
          id: imageUrl,
          onClick: () => setIndex(i),
        }))}
      />
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 0);
`;
